import { useState } from 'react';
import classnames from 'classnames';
import _isEmpty from 'lodash/isEmpty';
import { FCP } from 'types';

import Autosuggest from 'components/autosuggestInput';
import ZpButton from 'components/zpButton';
import { FILTER_PARAMS, filterSearchKey } from 'components/zpFilter/filterUtils';
import {
  buildCmpSubpagesUrls,
  buildUrlUsingTitleAndLocation,
  computeString,
  isValidLocationString,
  openInNewTab,
  splitLocation,
} from 'utils';
import { CMP_SUBPAGES, CPP_SUBPAGES } from 'utils/constant';

import classes from './index.module.css';

export interface Props extends FCP {
  jobTitle?: string;
  userLocation?: string;
  redirectPage?: string;
  TitleTagName?: keyof JSX.IntrinsicElements;
  src?: string;
  redirectUrl?: string;
}

export const FindJobs = ({
  jobTitle,
  userLocation,
  className,
  redirectPage,
  TitleTagName,
  src,
  redirectUrl,
}: Props) => {
  const [title, setTitle] = useState(jobTitle);
  const [location, setLocation] = useState(userLocation);

  const onTitleChange = (e) => {
    if (!_isEmpty(e?.valueObj)) setTitle(e.displayValue);
    else setTitle('');
  };

  const onLocationChange = (e) => {
    if (!_isEmpty(e?.valueObj)) setLocation(e.displayValue);
    else setLocation('');
  };

  const onClick = () => {
    let url;

    if (title && location && location.length) {
      url = buildUrlUsingTitleAndLocation(title, location);
    } else if (title) {
      url = buildCmpSubpagesUrls(title, null, CMP_SUBPAGES.JOBS);
    } else if (location && location.length) {
      url = buildUrlUsingTitleAndLocation(null, location);
    }

    if (title && redirectPage === CMP_SUBPAGES.JOBS && !redirectUrl) {
      url = buildCmpSubpagesUrls(title, null, CMP_SUBPAGES.JOBS);

      if (isValidLocationString(location) && location !== '') {
        const { city, stateAbbr } = splitLocation(location);
        localStorage.setItem(
          filterSearchKey,
          JSON.stringify({
            [FILTER_PARAMS.LOCATION]: [
              {
                city: city,
                state: stateAbbr,
              },
            ],
          })
        );
      }
    } else if (redirectUrl && redirectPage === CPP_SUBPAGES.JOBS) {
      url = `${redirectUrl}${redirectPage}/#`;
      if (title) {
        url += `jobTitle=${title}`;
      }
      if (location) {
        url += `&location=${location}`;
      }
    }

    if (title && src) {
      url += src;
    }

    if (url) openInNewTab(url);
  };

  return (
    <div className={classnames(classes.container, className)}>
      <TitleTagName className={classnames('zp-title-h3 z-pt-0 text-capitalize', classes.title)}>
        {computeString('Search for', jobTitle.toLowerCase(), 'jobs')}
      </TitleTagName>
      <Autosuggest
        category="jobTitle"
        prefillValue={jobTitle}
        inputProps={{
          className: classnames('zp-input', classes.input),
          placeholder: 'Job Title',
        }}
        onChange={onTitleChange}
      />
      <Autosuggest
        category="location"
        prefillValue={location}
        inputProps={{
          className: classnames('zp-input', classes.input),
          placeholder: 'Location',
        }}
        onChange={onLocationChange}
      />
      <ZpButton
        className='z-mt-4'
        theme="super-primary"
        size="big"
        onClick={onClick}
        isFullWidth
      >
        Find Jobs
      </ZpButton>
    </div>
  );
};

FindJobs.defaultProps = {
  jobTitle: '',
  userLocation: '',
  className: '',
  redirectPage: null,
  TitleTagName: 'h3',
  src: '',
  redirectUrl: '',
};
